module.exports = new __parcel__URL__("father-michael.44a10438.webp").toString();